import React, { useEffect, useState, useCallback } from "react"
import Spiner from '../../components/General/Spiner'
import authLogic from "../../functions/logic/Auth"

const VerisChatAI = (props) => {
    const [messages, setMessages] = useState([])
    const [newMessage, setNewMessage] = useState("")
    const [spiner, setSpiner] = useState(false)

    const loadMessagesFromStorage = () => {
        //const savedMessages = localStorage.getItem("chatMessages")
        //if (savedMessages) {
        //    setMessages(JSON.parse(savedMessages))
        //}
    }

    const saveMessagesToStorage = (updatedMessages) => {
        localStorage.setItem("chatMessages", JSON.stringify(updatedMessages))
    }

    const addMessage = (text, type) => {
        const updatedMessages = [...messages, { text, type }]
        setMessages(updatedMessages)
        saveMessagesToStorage(updatedMessages)
    }

    const handleClearMessage = async () => {
        setMessages([])
    }

    const handleSendMessage = async () => {
        setSpiner(true)
        if (newMessage.trim() === "") return
        let expertMessage = "Gracias por tu mensaje. Estoy aquí para ayudarte. ¿En qué más puedo asistirte?"
        const userMessage = newMessage.trim()
        setNewMessage("")
        addMessage(userMessage, "user")
        const response = await authLogic.callApiAILogic(newMessage)

        if (response === undefined || response === null) {
            expertMessage = "Ocurrió un error, inténtelo en unos momentos";
        } else {
            if (response.success && response.code === 200 && response.data && response.data.narrative) {
                expertMessage = response.data.narrative
            } else {
                expertMessage = "No hubo respuesta para la pregunta";
            }
        }
        setTimeout(() => {
            setMessages((prevMessages) => {
                const updatedMessages = [...prevMessages, { text: expertMessage, type: "expert" }]
                saveMessagesToStorage(updatedMessages)
                return updatedMessages
            })
        }, 1000)
        setSpiner(false)
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSendMessage()
        }
    }

    const callAIApi = useCallback(async (message) => {
        const response = await authLogic.callApiAILogic(message)
        return response;
    }, [])

    useEffect(() => {
        loadMessagesFromStorage();
        if (props.message) {
            setMessages((prevMessages) => {
                const initialMessage = { text: props.message, type: "user" };
                const updatedMessages = [initialMessage, ...prevMessages];
                saveMessagesToStorage(updatedMessages);
                return updatedMessages;
            });

            callAIApi(props.message);
        }
    }, [props.message, callAIApi]); // Elimina `messages` de las dependencias


    return (
        <>
            {spiner && <Spiner opt={spiner} />}
            <div className="veris-chat-container">
                <div className="veris-content">
                    {messages.map((msg, index) => (
                        <div
                            key={index}
                            className={`veris-message ${msg.type === "user"
                                ? "veris-message-top"
                                : "veris-message-expert"
                                }`}
                        >
                            <span className="veris-message-text">{msg.text}</span>
                        </div>
                    ))}
                </div>
                <div className="veris-input-container">
                    <input
                        type="text"
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder="Escribe tu mensaje aquí..."
                        className="veris-input"
                    />
                    <button onClick={handleSendMessage} className="veris-send-button">
                        Enviar
                    </button>
                    <button onClick={handleClearMessage} className="veris-clear-button">
                        Limpiar
                    </button>
                </div>
            </div>
        </>
    )
}

export default VerisChatAI
